module.exports = __webpack_public_path__ + "bc4ff21c2f48d704eb4b2375e7222b1d.MP3";